export default __webpack_public_path__ + "static/media/RetailersBackButton.e090c79f.svg";